import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { DropdownOptionResponse } from '@/@types/responses/common/DropdownOptionResponse'
import { DropdownOptionsResponse } from '@/@types/responses/common/DropdownOptionsResponse'
import { MiscellaneousService } from './miscellaneous.service'

export class BuildStepService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public getBuildStepDropdownOptions(): Promise<DropdownOptionsResponse<DropdownOptionResponse<number>>> {
    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/build-steps/dropdown-options`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return json as DropdownOptionsResponse<DropdownOptionResponse<number>>
    })
  }
}
